export default __webpack_public_path__ + "static/media/accuracy.4debf68c.svg";